import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import turfQualityApi from '@/api/config/turfQualityApi'

function useSearchTurfQualityId( id: number) {
  return useQuery({
    queryKey: [queryKeys.turfQuality],
    queryFn: async () => {
      const { data } = await turfQualityApi.getById({ id })
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useSearchTurfQualityId